var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48597",
    "data-name": "Group 48597",
    transform: "translate(-1042 -668)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138032",
    "data-name": "Rectangle 138032",
    width: 24,
    height: 24,
    transform: "translate(1042 668)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49447",
    "data-name": "Group 49447",
    transform: "translate(6677.25 -13024.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49446",
    "data-name": "Group 49446",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93671",
    "data-name": "Path 93671",
    d: "M.75,5.75c0-3,1.5-5,5-5h8c3.5,0,5,2,5,5v10c0,3-1.5,5-5,5h-8c-3.5,0-5-2-5-5v-10Z",
    transform: "translate(-5633 13694)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93672",
    "data-name": "Path 93672",
    d: "M13.25,4.74V8.61a.5.5,0,0,1-.84.37L10.09,6.84a.5.5,0,0,0-.68,0L7.09,8.98a.5.5,0,0,1-.84-.37V.75h7Z",
    transform: "translate(-5633 13694)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_602",
    "data-name": "Line 602",
    x2: 4.25,
    transform: "translate(-5622 13706.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_603",
    "data-name": "Line 603",
    x2: 8.5,
    transform: "translate(-5626.25 13710.75)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume01);
export default __webpack_public_path__ + "static/media/resume01.bfc02405be6d10ea3b46e13db4e4b2ba.svg";
export { ForwardRef as ReactComponent };